import { pushUnique } from '@utils/arrays';

import * as els from './forumElements';

export const CLASS_BADWORDS_LIST = 'forum__badwords-list';

// Přidat click handler na odebrání pomocí křížku
export const deleteBadWords = (): void => {
  const deleteButtons = document.querySelectorAll('.forum__badwords-list-item-delete');
  if (deleteButtons && deleteButtons.length)
    deleteButtons.forEach((deleteButton) => {
      deleteButton.addEventListener('click', () => {
        deleteButton.parentElement?.remove();
      });
    });
};

// Zobrazit/skrýt seznam zakázaných výrazů
export const toggleBadwordsList = (): void => {
  const badWords = els.buttonToggleBadwords();
  if (badWords)
    // Po kliknutí na tlačítko
    badWords.addEventListener('click', (event) => {
      // 'Zobrazit/skrýt seznam zakázaných výrazů' v administraci
      const list: HTMLElement | null = document.querySelector(`.${CLASS_BADWORDS_LIST}`);
      if (list) list.classList.toggle(`${CLASS_BADWORDS_LIST}--hidden`);

      const buttonText = (event.target as HTMLButtonElement).querySelector('span');
      if (buttonText?.innerText)
        buttonText.innerText = buttonText.innerText === 'Skrýt' ? 'Zobrazit': 'Skrýt';
    });
};

// Ověřit unikátnost již použitých slov
export const getUniqueBadWords = (badWordsList: NodeListOf<HTMLSpanElement> | []): string => {
  if (!badWordsList) throw new Error('badWordsList is not defined');
  const badWords: string[] = [];

  badWordsList.forEach((el) => {
    pushUnique(badWords, el.innerHTML);
  });

  return badWords.join(', ');
};

// a přidat do dat k odeslání
export const addNewBadWords = (
  oldWords: NodeListOf<HTMLSpanElement> | [],
  newWord: string
): string => {
  const oldWordsInString: string = getUniqueBadWords(oldWords);

  if (oldWords.length === 0) return newWord;

  return !oldWordsInString.includes(newWord)
    ? oldWordsInString.concat(', ', newWord)
    : oldWordsInString;
};
